import React from "react";
export const Star = ({ color }: { color: string }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-2 -2 30 30"
  >
    <g id="Layer_1">
      <title>Star</title>
      <path
        stroke={color}
        id="svg_6"
        d="m17.57179,12.02614l-3.87534,0l-1.19627,-3.68161l-0.16797,0.5145l-1.02971,3.16782l-3.87429,-0.00071l3.13429,2.2775l-1.19839,3.68408l3.135,-2.2775l3.13571,2.27856l-1.19874,-3.68514l3.13571,-2.2775zm-4.65733,3.11312l-0.41464,-0.30101l-0.41464,0.30136l-1.37694,1.00007l0.52579,-1.61761l0.1588,-0.48768l-0.41534,-0.30171l-1.37624,-1.00007l2.21433,0l0.1588,-0.48733l0.52544,-1.61761l0.52544,1.61655l0.15844,0.48733l2.21645,0l-1.37836,1.00077l-0.41569,0.30136l0.15844,0.48839l0.52685,1.61761l-1.37694,-1.00042z"
        strokeWidth="5"
        fill="#fff"
      />
    </g>
  </svg>
);
